import type { AgentInstallCommand } from './types.js';
import { claudeCodeInstallCommand } from './claude-code.js';
import { codexAcpInstallCommand } from './codex-acp.js';
import { cursorCliInstallCommand } from './cursor-cli.js';
import { opencodeInstallCommand } from './opencode.js';

const COMMANDS: AgentInstallCommand[] = [
  claudeCodeInstallCommand,
  codexAcpInstallCommand,
  cursorCliInstallCommand,
  opencodeInstallCommand,
];

const byType = new Map(COMMANDS.map((c) => [c.agentType, c]));

export function getAgentInstallCommand(agentType: string): AgentInstallCommand | undefined {
  return byType.get(agentType);
}

export { type AgentInstallCommand, type AgentInstallContext } from './types.js';
